// import { gqlClient } from 'src/common/services/api/GraphQLRequestApi';
import { Logger } from 'src/common/services/Logger';

import {
	IUniqueIssuesFilterOptions,
	transformUniqueIssuesFilterOptions
} from '../queries/unique-issues-filters/helpers/transformResults';
import { GetUniqueIssuesFilterOptionsQuery } from '../queries/unique-issues-filters/UniqueIssuesFilterOptions.generated';
// import { GetUniqueIssuesFilterOptions } from '../queries/unique-issues-filters/UniqueIssuesFilterOptions.gql';

const getMockData = (): GetUniqueIssuesFilterOptionsQuery => ({
	uniqueness_issues: [
		{ severity: 'Critical', issue_type: 'Accessibility', __typename: 'uniqueness_issues' },
		{ severity: 'Serious', issue_type: 'Accessibility', __typename: 'uniqueness_issues' },
		{ severity: 'Moderate', issue_type: 'Best Practice', __typename: 'uniqueness_issues' },
		{ severity: 'Minor', issue_type: 'Best Practice', __typename: 'uniqueness_issues' },
		{ severity: 'Critical', issue_type: 'Usability', __typename: 'uniqueness_issues' },
		{ severity: 'Serious', issue_type: 'Usability', __typename: 'uniqueness_issues' }
	],
	__typename: 'Query'
});

export const getUniqueIssuesFilterOptions = async (): Promise<IUniqueIssuesFilterOptions> => {
	try {
		// Using mock data for development
		const result = getMockData();

		// Real GraphQL request (commented out until backend is ready)
		// const result = await gqlClient.request<GetUniqueIssuesFilterOptionsQuery>(
		// 	GetUniqueIssuesFilterOptions
		// );

		const transformedResult = transformUniqueIssuesFilterOptions(result);
		return transformedResult;
	} catch (e) {
		Logger.error('UniqueIssuesFilterOptionsService -> getUniqueIssuesFilterOptions failed:', e);
		throw e;
	}
};
